function registerFeaturedCta() {
  // verify that the widget exists to avoid console errors.
  const widget = document.querySelector('.featured-cta-cards')

  if (widget) {
    const nextButtons = document.querySelectorAll('.btn-mobile-next')
    const prevButtons = document.querySelectorAll('.btn-mobile-prev')

    nextButtons.forEach(button => {
      button.addEventListener('click', event => {
        const currentCard = button.parentElement
        const nextCard = currentCard.nextElementSibling

        if (nextCard) {
          currentCard.style.setProperty('visibility', 'hidden')
          currentCard.style.setProperty('opacity', '0')
          nextCard.style.setProperty('visibility', 'visible')
          nextCard.style.setProperty('opacity', '1')
        }
      })
    })

    prevButtons.forEach(button => {
      button.addEventListener('click', event => {
        const currentCard = button.parentElement
        const previousCard = currentCard.previousElementSibling

        if (previousCard) {
          currentCard.style.setProperty('visibility', 'hidden')
          currentCard.style.setProperty('opacity', '0')
          previousCard.style.setProperty('visibility', 'visible')
          previousCard.style.setProperty('opacity', '1')
        }
      })
    })
  }
}


document.addEventListener('DOMContentLoaded', (event) => {
  registerFeaturedCta()
})
